import { ContactPage } from '../ContactPage/ContactPage'

export function ContactChannelReportPage (props) {
  return <ContactPage pageName={props.pageName} isContactReportChannelPage={true}/>
}
